import React, { FC, ReactElement, useContext } from 'react'
import { Select } from '../../Common/Components/Selects'
import { Timezone } from '../../../../i18n'
import FormRow from '../../Common/Components/FormRow'
import CLanguageHandler from '../../../NonReact/Languages/LanguageHandler'
import { LanguageContext } from '../../Common/Contexts'
import { timezonesToSelectOptions } from '../Mappers/Timezone'
import { DEFAULT_TIMEZONE } from '../Constants/Constants'
import { TIMEZONE_COMPONENT_NAME } from '../Constants/FieldNames'
import { HelpTag } from '../../Common/Components/HelpTag/HelpTag'
import { HelpTagTitles, Tags } from '../../Common/API/Contentful/Constants'
import { IconSize } from '../../../NonReact/constants/React/Icon/Constants'

export const MainTab: FC = (): ReactElement => {
    const language: CLanguageHandler = useContext(LanguageContext) as CLanguageHandler
    language.loadBundle(Timezone.NAME)

    return (
        <>
            <FormRow className='timezone-change-modal'>
                <Select
                    name={TIMEZONE_COMPONENT_NAME}
                    options={timezonesToSelectOptions(language)}
                    defaultValue={DEFAULT_TIMEZONE}
                />

                <HelpTag
                    helpContentTitle={HelpTagTitles.TIMEZONE_MODAL}
                    tag={Tags.TIMEZONE}
                    iconSize={IconSize.GIANT}
                />
            </FormRow>
        </>
    )
}
